import { postAPI } from 'framework/api/http';
import { useMutation } from 'react-query';

interface AddCategoryInterface {
  categoryName: string;
}

export const useAddCategory = () => {
  const mutate = useMutation(({ categoryName }: AddCategoryInterface) => {
    return postAPI('/external-api/add_categories', {
      category_name: categoryName,
    });
  });

  return mutate;
};

export default useAddCategory;
